import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Avatar from "react-avatar";

function OrderDetailsModal(props) {
    return (
        <>
            <Modal className={'modal-full text-center'} isOpen={props.modal} toggle={props.modalToggle}>
                <ModalHeader toggle={props.modalToggle} close={
                    <button className="close" onClick={props.modalToggle}>
                        &times;
                    </button>
                }>Order Items</ModalHeader>
                <ModalBody>
                    <table className="table mb-0" style={{ marginTop: '-17px' }}>
                        <thead>
                            <tr>
                                {/*<th>#</th>*/}
                                {/*<th>Image</th>*/}
                                {/*<th>Item Name</th>*/}
                                {/*<th>Price Before tax</th>*/}
                                {/*<th>Tax Percentage</th>*/}
                                {/*<th>Tax Amount</th>*/}
                                {/*<th>Price After Tax</th>*/}
                                {/*<th>Discount</th>*/}
                                {/*<th>Quantity</th>*/}
                                {/*<th>Total</th>*/}

                                <th>#</th>
                                <th>Image</th>
                                <th>Item Name</th>
                                <th>Item Type</th>
                                <th>Rate</th>
                                <th>Quantity</th>
                                <th>Price Before Tax(Before Discount)</th>
                                <th>Price Before Tax(After Discount)</th>
                                <th>Tax Percentage</th>
                                <th>Tax Amount</th>
                                <th>Price After Tax</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.order.order_items.map((cart, index) => (
                                // <tr key={item.id}>
                                //     <th scope="row">{index + 1}</th>
                                //     <td>
                                //         {item?.product_add_on_item?.product_image || item?.product_group_add_on_item?.product_group_image ? (
                                //             <img
                                //                 src={
                                //                     item?.product_add_on_item?.product_image ||
                                //                     item?.product_group_add_on_item?.product_group_image
                                //                 }
                                //                 className="avatar-sm img-thumbnail rounded-circle"
                                //                 alt="product"
                                //             />
                                //         ) : (
                                //             <Avatar
                                //                 size={35}
                                //                 name={
                                //                     item?.name
                                //                 }
                                //                 round
                                //             />
                                //         )}
                                //     </td>
                                //     <td style={{ height: '40px' }}>
                                //         {item.name.substring(0, 12)}
                                //         {item.product_add_on_item?.add_on_products && item.product_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     {addOn.name}
                                //                 </div>
                                //             </div>
                                //         ))}
                                //         {item.product_group_add_on_item?.add_on_products && item.product_group_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     {addOn.name}
                                //                 </div>
                                //             </div>
                                //         ))}
                                //         {item.coupon && (
                                //             <span>
                                //                 Applied Coupon: {item.coupon}
                                //             </span>
                                //         )}
                                //     </td>
                                //     <td>
                                //         ₹ {item.product_add_on_item?.price_before_tax ||
                                //             item.product_group_add_on_item?.price_before_tax}
                                //         {item.product_add_on_item?.add_on_products && item.product_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     ₹ {addOn.price_before_tax}
                                //                 </div>
                                //             </div>
                                //         ))}
                                //         {item.product_group_add_on_item?.add_on_products && item.product_group_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     ₹ {addOn.price_before_tax}
                                //                 </div>
                                //             </div>
                                //         ))}
                                //     </td>
                                //     <td>
                                //         {item?.tax_percentage?.toFixed(2)} %
                                //         <span className="text-muted ml-1">
                                //             ({item.product_add_on_item?.tax_type === 'TAX-INCLUSIVE' || item.product_group_add_on_item?.tax_type === 'TAX-INCLUSIVE' ? 'incl' : 'excl'})
                                //         </span>
                                //         {item.product_add_on_item?.add_on_products && item.product_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     {addOn.tax_percentage} %
                                //                     <span className="text-muted ml-1">
                                //                         ({addOn.tax_type === 'TAX-INCLUSIVE' ? 'incl' : 'excl'})
                                //                     </span>
                                //                 </div>
                                //             </div>
                                //         ))}
                                //         {item.product_group_add_on_item?.add_on_products && item.product_group_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     {addOn.tax_percentage} %
                                //                     <span className="text-muted ml-1">
                                //                         ({addOn.tax_type === 'TAX-INCLUSIVE' ? 'incl' : 'excl'})
                                //                     </span>
                                //                 </div>
                                //             </div>
                                //         ))}
                                //     </td>
                                //     <td>
                                //         ₹ {item?.tax_amount?.toFixed(2)}
                                //         {item.product_add_on_item?.add_on_products && item?.product_add_on_item?.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     ₹ {addOn.tax_amount}
                                //                 </div>
                                //             </div>
                                //         ))}
                                //         {item.product_group_add_on_item?.add_on_products && item.product_group_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     ₹ {addOn.tax_amount}
                                //                 </div>
                                //             </div>
                                //         ))}
                                //     </td>
                                //     <td>
                                //         ₹ {item.product_add_on_item?.price_after_tax ||
                                //             item.product_group_add_on_item?.price_after_tax}
                                //         {item.product_add_on_item?.add_on_products && item.product_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     ₹ {addOn.price_after_tax}
                                //                 </div>
                                //             </div>
                                //         ))}
                                //         {item.product_group_add_on_item?.add_on_products && item.product_group_add_on_item.add_on_products.map((addOn, addOnIndex) => (
                                //             <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                //                 <div className="addon-item" style={{ marginLeft: '5px' }}>
                                //                     ₹ {addOn.price_after_tax}
                                //                 </div>
                                //             </div>
                                //         ))}
                                //     </td>
                                //     <td>₹ {(item?.coupon_discount ?? 0).toFixed(2)}</td>
                                //     <td>{item.quantity}</td>
                                //     <td className="total-width">₹ {item?.amount_total_after_tax.toFixed(2)}</td>
                                // </tr>

                                <tr key={cart.id}>
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        {cart?.product_add_on_item?.product?.image || cart?.product_group_add_on_item?.product_group?.image ? (
                                            <img
                                                src={
                                                    cart?.product_add_on_item?.product?.image ||
                                                    cart?.product_group_add_on_item?.product_group?.image
                                                }
                                                className="avatar-sm img-thumbnail rounded-circle"
                                                alt="product"
                                            />
                                        ) : (
                                            <Avatar
                                                size={35}
                                                name={
                                                    cart?.product_add_on_item?.product?.name ||
                                                    cart?.product_group_add_on_item?.product_group?.name
                                                }
                                                round
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {cart.name}
                                        {cart.product_add_on_item?.add_on_product && cart.product_add_on_item?.add_on_product.map((addOn, addOnIndex) => (
                                            <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                                <div className="addon-item" style={{ marginLeft: '5px' }}>
                                                    {addOn.name}
                                                </div>
                                            </div>
                                        ))}
                                        {cart.product_group_add_on_item?.add_on_product && cart.product_group_add_on_item?.add_on_product.map((addOn, addOnIndex) => (
                                            <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>
                                                <div className="addon-item" style={{ marginLeft: '5px' }}>
                                                    {addOn.name}
                                                </div>
                                            </div>
                                        ))}
                                        {cart.coupon && (
                                            <span>
                                            Applied Coupon: {cart.coupon}
                                        </span>
                                        )}
                                    </td>
                                    <td>{cart.type}</td>
                                    <td>₹ {cart.rate}</td>
                                    <td>{cart.quantity}</td>
                                    <td>{cart.amount_total_before_tax_before_discount}</td>
                                    <td>{cart.amount_total_before_tax_after_discount}</td>
                                    <td>{cart.tax_percentage} %</td>
                                    <td>₹ {cart.tax_amount}</td>
                                    <td>₹ {cart.total_amount}</td>
                                    {/*<td>*/}
                                    {/*    {cart.product_add_on_item?.product.tax_percentage ||*/}
                                    {/*        cart.product_group_add_on_item?.product_group?.tax_percentage.toFixed(2)} %*/}
                                    {/*    <span className="text-muted ml-1">*/}
                                    {/*        ({cart.product_add_on_item?.product.tax_type === 'TAX-INCLUSIVE' || cart.product_group_add_on_item?.product_group?.tax_type === 'TAX-INCLUSIVE' ? 'incl' : 'excl'})*/}
                                    {/*    </span>*/}
                                    {/*    {cart.product_add_on_item?.product && cart.product_add_on_item.add_on_product.map((addOn, addOnIndex) => (*/}
                                    {/*        <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>*/}
                                    {/*            <div className="addon-item" style={{ marginLeft: '5px' }}>*/}
                                    {/*                {addOn.tax_percentage} %*/}
                                    {/*                <span className="text-muted ml-1">*/}
                                    {/*                    ({addOn.tax_type === 'TAX-INCLUSIVE' ? 'incl' : 'excl'})*/}
                                    {/*                </span>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    ))}*/}
                                    {/*    {cart.product_group_add_on_item?.add_on_product && cart.product_group_add_on_item.add_on_product.map((addOn, addOnIndex) => (*/}
                                    {/*        <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>*/}
                                    {/*            <div className="addon-item" style={{ marginLeft: '5px' }}>*/}
                                    {/*                {addOn.tax_percentage} %*/}
                                    {/*                <span className="text-muted ml-1">*/}
                                    {/*                    ({addOn.tax_type === 'TAX-INCLUSIVE' ? 'incl' : 'excl'})*/}
                                    {/*                </span>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    ))}*/}
                                    {/*</td>*/}
                                    {/*<td>*/}
                                    {/*    ₹ {cart.product_add_on_item?.product.tax_amount ||*/}
                                    {/*    cart.product_group_add_on_item.product_group?.tax_amount}*/}
                                    {/*    {cart.product_add_on_item?.product && cart.product_add_on_item.add_on_product.map((addOn, addOnIndex) => (*/}
                                    {/*        <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>*/}
                                    {/*            <div className="addon-item" style={{ marginLeft: '5px' }}>*/}
                                    {/*                ₹ {addOn.tax_amount}*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    ))}*/}
                                    {/*    {cart.product_group_add_on_item?.add_on_product && cart.product_group_add_on_item.add_on_product.map((addOn, addOnIndex) => (*/}
                                    {/*        <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>*/}
                                    {/*            <div className="addon-item" style={{ marginLeft: '5px' }}>*/}
                                    {/*                ₹ {addOn.tax_amount}*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    ))}*/}
                                    {/*</td>*/}
                                    {/*<td>*/}
                                    {/*    ₹ {cart.product_add_on_item?.product.price_after_tax ||*/}
                                    {/*    cart.product_group_add_on_item?.product_group?.price_after_tax}*/}
                                    {/*    {cart.product_add_on_item?.product && cart.product_add_on_item.add_on_product.map((addOn, addOnIndex) => (*/}
                                    {/*        <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>*/}
                                    {/*            <div className="addon-item" style={{ marginLeft: '5px' }}>*/}
                                    {/*                ₹ {addOn.price_after_tax}*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    ))}*/}
                                    {/*    {cart.product_group_add_on_item?.add_on_product && cart.product_group_add_on_item.add_on_product.map((addOn, addOnIndex) => (*/}
                                    {/*        <div key={addOnIndex} style={{ marginTop: '5px', fontSize: '12px', color: '#888' }}>*/}
                                    {/*            <div className="addon-item" style={{ marginLeft: '5px' }}>*/}
                                    {/*                ₹ {addOn.price_after_tax}*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    ))}*/}
                                    {/*</td>*/}
                                    {/*<td>₹ {cart.coupon_discount === null || cart.coupon_discount === "0.00" ? '0.00' : cart.coupon_discount}</td>*/}
                                    {/*<td>₹ {cart?.amount_total_after_tax}</td>*/}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/*<div>*/}
                    {/*    <p style={{ height: '60px', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', margin: 0, padding: '10px' }}>*/}
                    {/*        Order Items Total:  ₹ {props.order.total_amount}*/}
                    {/*    </p>*/}
                    {/*</div>*/}
                </ModalBody>

                <ModalFooter className="d-flex justify-content-end">
                    <div style={{ textAlign: 'right', lineHeight: '1.8' }}>
                        <p className="mb-0">
                            <strong>Sub Total:</strong> ₹ {props.order.sub_total_before_discount} <br />
                            {props.order.order_discount > 0 && (
                                <>
                                    <strong>Discount:</strong> ₹ {props.order.order_discount} <br />
                                    <strong>Sub Total (After Discount):</strong> ₹ {props.order.sub_total_after_discount} <br />
                                </>
                            )}
                            <strong>Effective Tax Percentage:</strong> {props.order?.effective_tax_percentage} % <br />
                            {props.order?.cgst > 0 && (
                                <>
                                    <strong>CGST:</strong> ₹ {props.order?.cgst} <br />
                                </>
                            )}
                            {props.order?.sgst > 0 && (
                                <>
                                    <strong>SGST:</strong> ₹ {props.order?.sgst} <br />
                                </>
                            )}
                            {props.order?.utgst > 0 && (
                                <>
                                    <strong>UTGST:</strong> ₹ {props.order?.utgst} <br />
                                </>
                            )}
                            {props.order?.igst > 0 && (
                                <>
                                    <strong>IGST:</strong> ₹ {props.order?.igst} <br />
                                </>
                            )}
                            <strong>Total Tax Amount:</strong> ₹ {props.order?.total_tax_amount || 0.00} <br />
                            <strong>Total Amount:</strong> ₹ {props.order?.total_amount || 0.00}
                            {props.order?.reference_order_id && (
                                <>
                                    <br />
                                    <strong>Reference Order ID:</strong>{' '}
                                    <span style={{ fontFamily: 'monospace', fontSize: 13 }}>
                                        {props.order.reference_order_id}
                                    </span>
                                </>
                            )}
                        </p>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default OrderDetailsModal;